const RulesTab = ({ html }) => {
  if (!html || !html.trim()) {
    return (
      <div className="border border-dashed border-border/60 px-6 py-12 text-center text-sm text-muted-foreground">
        No rules posted yet.
      </div>
    );
  }
  return (
    <article
      className="tournament-rules-body prose prose-sm max-w-none rounded-md border border-border/60 bg-background/40 p-6 text-sm text-foreground sm:text-base
        [&_[style*='background']]:!bg-transparent
        [&_a]:!text-heat [&_a]:underline-offset-2 hover:[&_a]:underline
        [&_h1]:mb-3 [&_h1]:mt-6 [&_h1]:font-display [&_h1]:text-2xl [&_h1]:font-semibold
        [&_h2]:mb-2 [&_h2]:mt-5 [&_h2]:font-display [&_h2]:text-xl [&_h2]:font-semibold
        [&_h3]:mb-2 [&_h3]:mt-4 [&_h3]:font-display [&_h3]:text-lg [&_h3]:font-semibold
        [&_p]:my-3 [&_p]:leading-relaxed
        [&_ul]:my-3 [&_ul]:ml-5 [&_ul]:list-disc [&_ul]:space-y-1
        [&_ol]:my-3 [&_ol]:ml-5 [&_ol]:list-decimal [&_ol]:space-y-1
        [&_strong]:font-semibold [&_em]:italic
        [&_code]:rounded [&_code]:bg-muted [&_code]:px-1 [&_code]:py-0.5 [&_code]:font-mono [&_code]:text-[0.9em]
        [&_img]:my-4 [&_img]:max-w-full [&_img]:rounded-md [&_img]:border [&_img]:border-border/60
        [&_blockquote]:my-3 [&_blockquote]:border-l-2 [&_blockquote]:border-heat [&_blockquote]:pl-4 [&_blockquote]:text-muted-foreground"
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
};

export default RulesTab;
